// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11GGL","delete":"styles_delete__1LQog","update":"styles_update__1fLU1","add":"styles_add__2ZKvF"};